{"schemaVersion":1,"release":{"version":"1.0.6","build":127,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.6-127.dmg","sha256":"2f94bd8d99365d085f4d02027e5e4116222ea0a4a94551b328e97699fb0e75d1","size":27439787}}
